module.exports = __webpack_public_path__ + "img/car_yellow.68887ee1.png";